// extracted by mini-css-extract-plugin
export default {"container":"removePermissionGroup_container__Pa1RI"};